define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'es6!launcher/actions/ListBuilderActions',
], (Util, Immutable, _, Actions) => {
  const initialState = Immutable.Map({
    list: Immutable.List(),
    byId: Immutable.Map(),
    errors: new Immutable.Map(),
    loading: false,
    fetchedAt: 0,
    textFilter: '',
  });

  const actionHandlers = {};

  function updateTestWeights(test) {
    const total = _.reduce(test, (memo, variant) => variant.weight + memo, 0);
    test.forEach((variant) => {
      variant.weight_percent = Math.round((variant.weight / total) * 100);
    });
  }

  function updateAllTestWeights(tests) {
    tests.forEach((test) => updateTestWeights(test));

    return tests;
  }

  actionHandlers[Actions.REQUEST_TESTS] = (state, action) => state.set('loading', true);

  actionHandlers[Actions.ERROR_TESTS] = (state, action) => {
    const code = action.code;
    const error = action.error;
    const retState = state.set('loading', false);

    return retState.mergeIn(['errors'], { [code]: `${error}` });
  };

  actionHandlers[Actions.INVALIDATE_TESTS_CACHE] = (state, action) => {
    return state.set('fetchedAt', 0);
  };

  actionHandlers[Actions.RECEIVE_TESTS] = (state, action) => {
    const tests = _.compact(action.tests);
    const byId = {};

    _.each(tests, (test) => {
      if (test) {
        byId[test[0].id] = _.sortBy(test, 'variant');
      }
    });

    let retState = state.set('byId', Immutable.fromJS(byId));
    retState = retState.set('list', Immutable.fromJS(
      _.map(updateAllTestWeights(tests), (test) => {
        return _.sortBy(test, 'variant');
      }),
    ));
    retState = retState.set('loading', false);
    retState = retState.deleteIn(['errors', 'fetch']);
    retState = retState.set('fetchedAt', Date.now());

    return retState;
  };

  actionHandlers[Actions.UPDATE_TEST_TEXT_FILTER] = (state, action) => {
    return state.set('textFilter', action.filter);
  };

  actionHandlers[Actions.RECEIVE_TEST] = (state, action) => state.setIn(['byId', action.test.id], Immutable.fromJS(action.test));

  actionHandlers[Actions.UPDATE_VARIANT_WEIGHT] = (state, action) => {
    const tests = state.get('list').toJS();
    const testId = action.testId;
    const variantId = action.variantId;
    const weight = action.weight;

    const test = _.find(tests, (test) => test[0].id === testId);
    if (test) {
      const variant = _.find(test, (variant) => variant.id === variantId);
      if (variant) {
        variant.weight = weight;
      }

      return state.set('list', Immutable.fromJS(updateAllTestWeights(tests)));
    }

    return state;
  };

  return Util.createReducer(initialState, actionHandlers);
});
